import script from "./CircleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleButton.vue?vue&type=script&setup=true&lang=js"

import "./CircleButton.vue?vue&type=style&index=0&id=4257314c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4257314c"]])

export default __exports__